import { create } from 'zustand';

// グローバルヘッダー（app-layout / MainNav）に出すパンくず用の共有状態。
// 選択中のプロジェクト/チーム/スレッド名はチャット画面(console-page)のローカル state にあるため、
// ヘッダー側から参照できるよう、表示用の名前だけをここへ吸い上げる。
// 画面遷移したらチャット側で setBreadcrumb(null) して消す。

export interface Breadcrumb {
  project: string | null;
  team: string | null;
  thread: string | null;
}

interface BreadcrumbState {
  crumb: Breadcrumb | null;
  setBreadcrumb: (crumb: Breadcrumb | null) => void;
}

export const useBreadcrumbStore = create<BreadcrumbState>((set) => ({
  crumb: null,
  setBreadcrumb: (crumb) => set({ crumb }),
}));
